export class InsuranceCompanyConstant {
    public static readonly GENERALI = "GENERALI";
    public static readonly CHUBB = "CHUBB";
    public static readonly ZURICH = "ZURICH";
    public static readonly ETIQA = "ETIQA";
    public static readonly KURNIA = "KURNIA";
    public static readonly TUNE = "TUNE";
  }
  